import React, {useContext, useEffect} from "react";
import SidePanelLayout from "layouts/SidePanelLayout";
import {
    SWIFT_MESSAGE_SEARCH
} from "../../../routes/Routes";
import {useLocation} from "react-router";
import {SwiftMessageContext} from "./context";
import AuthenticationService from "../../../service/AuthenticationService";
import SwiftMessageFilter from "./SwiftMessageFilter";
import SwiftPanel from "./SwiftPanel";

export default function Swift() {
    const {pathname} = useLocation();
    const {currentSwiftLayout, setCurrentSwiftLayout, loadTrigger, setLoadTrigger, loadSwiftMessages} = useContext(SwiftMessageContext)


    const getCurrentSwiftLayout = (pathname)=>{
        let page;
        if(pathname === SWIFT_MESSAGE_SEARCH){
            page = renderSSALayout(SwiftMessageFilter, SwiftPanel )
        }
        setCurrentSwiftLayout(page)
    }

    useEffect(()=>{
        getCurrentSwiftLayout(pathname)
    },[pathname])

    useEffect(()=>{

        if(loadTrigger) {
            const userEntities = AuthenticationService.getEntityAccountsNoSwap();
            loadSwiftMessages(userEntities[0])

            setLoadTrigger(false)
        }


    },[loadTrigger, setLoadTrigger])

    const renderSSALayout = (sideComponent, mainComponent)=>(
        <SidePanelLayout
            sideComponent={sideComponent}
            mainComponent={mainComponent}
        />
    )

    return(
        <>
            {currentSwiftLayout}
        </>
    )
}
